import Cookie from 'universal-cookie';
import { COOKIE_JWT_TOKEN_SIMAC } from 'constants/cookies';

const cookie = new Cookie();

export const logout = ({ redirect }) => {
  cookie.remove(COOKIE_JWT_TOKEN_SIMAC);
  window.location.href = redirect;
};
